import { GenericLandingCard, GenericLandingCardHeader } from "components";
import { GenericBackToBtn, ResendVerifyEmailBtn } from "components/buttons";
import { useAppSelector } from "../store/store";
import {
  verifyEmailTitle,
  buttonBack,
  verifyEmailSubTitle,
  verifyEmailSubTitle2,
} from "../_constants";

export const VerifyEmailPage = () => {
  const email = useAppSelector((state) => state.registerFormSlice.value.email);

  return (
    <GenericLandingCard
      rightColumn={
        <GenericLandingCardHeader
          title={verifyEmailTitle}
          subtitle={
            <>
              {verifyEmailSubTitle}
              <span className="font-weight-700">{` ${email}`}</span>
              {verifyEmailSubTitle2}
            </>
          }
          gap={16}
        ></GenericLandingCardHeader>
      }
      leftInteraction={<GenericBackToBtn label={buttonBack} link="/register" />}
      rightInteraction={<ResendVerifyEmailBtn />}
    ></GenericLandingCard>
  );
};
